export const OrderStatus = {
  in_validation: 'Em validação',
  pending: 'A confirmar',
  confirmed: 'Confirmada',
  sent: 'Enviada',
  delivered: 'Entregue',
  rejected: 'Rejeitada',
};

export const NewOrderStatus = {
  in_validation: 'WAITING_SALES_ORDER_VALIDATION',
  pending: 'TO_BE_CONFIRMED',
  confirmed: 'CONFIRMED',
  invoice_received: 'INVOICE_RECEIVED',
  sent: 'SHIPPED',
  shipping_confirmed: 'SHIPPING_CONFIRMED',
  delivered: 'DELIVERED',
  cancelled: 'CANCELLED',
  under_review: 'UNDER_REVIEW',
};

export const OrderSellerPaymentStatus = {
  NOT_PAID: 'NOT_PAID',
  CONSOLIDATED: 'CONSOLIDATED',
  PAID: 'PAID',
};

export const OrderSource = {
  MARKETPLACE: 'MARKETPLACE',
  VENDORS_PORTAL: 'VENDORS_PORTAL',
  SALES_APP: 'SALES_APP',
  SHOPIFY: 'SHOPIFY',
  BACKOFFICE: 'BACKOFFICE',
};

export const ShippingDocumentsTypes = {
  CTE: 'CTE',
  DELIVERY_RECEIPT: 'DELIVERY_RECEIPT',
};

export const ACCEPTED_FILE_TYPES = '.jfif,.jpeg,.jpg,.pdf,.png,.x-png,.xml';

export const InstallmentsStatus = {
  PENDING: 'pending',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  SENT: 'sent',
};
